import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-header-row.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIHeaderRow
 * @element ui-header-row
 * @classdesc Represents a class for <code>ui-header-row</code> element.
 * @example
 * <ui-header-row></ui-header-row>
 */
@Component({ tag: 'ui-header-row', styles })
export class UIHeaderRow extends UIElement {}
